import React, { useEffect, useState } from "react";
import Modal from "react-modal"; // Install 'react-modal' if not already installed
import sizeTop from "../../images/size_top.png";
import sizeBottom from "../../images/size_bottom.png";
import { FaTimes } from "react-icons/fa";

const SizeChart = ({ isOpen, onClose, order }) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "auto", // adjust as needed
      maxHeight: "auto", // adjust as needed
      overflow: "auto",
      padding: "20px",
      borderRadius: "10px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000, // ensure it overlays other content
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Size Chart"
      style={customStyles}
    >
      <div>
        <div className="flex justify-between">
          <p></p>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            <FaTimes size={24} />
          </button>
        </div>

        {["SHIRTS", "T-SHIRT", "HOODIE"].includes(order.category) && (
          <img
            src={sizeTop}
            alt="size"
            className="md:h-96 object-cover rounded-md"
          />
        )}
        {["PANTS", "CARGO"].includes(order.category) && (
          <img
            src={sizeBottom}
            alt="size"
            className="md:h-96 object-cover rounded-md"
          />
        )}
      </div>
    </Modal>
  );
};

export default SizeChart;
